<panel width="600">
	<form>
		<section>
			<div>
				<custom-select [required]="true"
					[selectList]="nextPeriodSelect"
					[(value)]="updatedNextPeriod"
					[label]="'company.product-plans.edit-auto-revewal.next-period' | translate"></custom-select>
			</div>
			<div>
				<custom-input [label]="'company.product-plans.edit-auto-revewal.annual-value-for-renewal' | translate"
					[inputType]="inputType.Currency"
					[(value)]="updatedProductPlanAnnualValueForRenewal"
					[required]="true"></custom-input>
			</div>
		</section>
		<section>
			<button confirm (click)="saveProductPlan()" [label]="'general.save' | translate"></button>
		</section>
	</form>
</panel>
